import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getMediaTaskCountsInStore } from "@coworker/apprestructured/src/task-management/services/tasks.service";

/**
 * Fetch v2 task counts for all medias in a store (aggregated)
 * Uses single endpoint: GET /tasks-v2/count
 * Returns Map<mediaId, v2TaskCount>
 * Note: Backend uses user's auth context to determine store
 */
export function useMediaTaskCountsV2(
  taskTypeIds: string[]
): UseQueryResult<Map<string, number>> {
  return useQuery({
    queryKey: ["media-task-counts-v2", [...taskTypeIds].sort().join(",")],
    queryFn: async () => {
      if (taskTypeIds.length === 0) {
        return new Map<string, number>();
      }

      const counts = await getMediaTaskCountsInStore(taskTypeIds);

      // Convert Record to Map
      const map = new Map<string, number>();
      Object.entries(counts).forEach(([mediaId, count]) => {
        map.set(mediaId, count);
      });
      return map;
    },
    enabled: taskTypeIds.length > 0,
    staleTime: 30000, // 30 seconds
    gcTime: 60000, // 60 seconds
  });
}
